import classes from "./image.module.css";

import React, { useState } from "react";

export enum ImageLoadStatus {
  LOADING = "is-loading",
  LOADED = "has-loaded",
  FAILED = "has-failed",
}

export type ImageLazyProps = {
  sources: Array<{ src: string; alt: string; classes?: string }>;
};

export const ImageLazy = ({ sources }: ImageLazyProps) => {
  const [status, setStatus] = useState(ImageLoadStatus.LOADING);

  return (
    <div className={`${classes["picture"]} ${status}`}>
      <div className={classes["placeholder"]}></div>
      {sources.map((img, idx) => {
        const imgClasses = `${img.classes} ${classes["img"]}`;

        return (
          <img
            key={idx}
            src={img.src}
            alt={img.alt}
            className={imgClasses}
            onLoad={() => setStatus(ImageLoadStatus.LOADED)}
            onError={() => setStatus(ImageLoadStatus.FAILED)}
          />
        );
      })}
    </div>
  );
};
